import { createStyle } from "~/common/utils/create-style";

const chatLayoutStyle = createStyle({
  slots: {
    container: [
      "flex flex-col w-full mx-auto fixed inset-0 bg-surface-10",
      "max-w-full overflow-hidden",
      "transition-all duration-100 ease-linear",
      "pwa:flex-[0_1_100vh]",
    ],
    scrollArea: [
      "relative flex flex-col px-32 ",
      "overflow-y-auto overflow-x-hidden overscroll-y-none",
      "flex-[1_1_calc(var(--viewport-height,100dvh)-6.8rem)]",
      "lg:flex-[1_1_var(--viewport-height,100dvh)]",
      "focus:outline-none",
    ],
    content: [
      "flex flex-col-reverse justify-between",
      "pt-[calc(env(safe-area-inset-top,1.5rem)+62px)]",
      "gap-y-12 flex-[0_1_100dvh]",
    ],
    messageList: [
      "flex flex-col",
      "gap-y-24 flex-[1_1_0%]",
      "w-full max-w-6xl mx-auto",
    ],
    formArea: [
      "sticky bottom-0 z-10",
      "pb-0 md:pb-4 w-full grow-0 shrink-0 bg-surface-10",
    ],
    formAreaContent: [
      "flex flex-col max-w-6xl mx-auto mb-24 sm:mb-40",
      "gap-y-6 w-full md:pb-0 pwa:pb-[env(safe-area-inset-bottom)]",
    ],
  },
})();

export { chatLayoutStyle };
